import { render } from "./HomeMenuOwnerUsage.vue?vue&type=template&id=40a4b008"
import script from "./HomeMenuOwnerUsage.vue?vue&type=script&lang=js"
export * from "./HomeMenuOwnerUsage.vue?vue&type=script&lang=js"
script.render = render

export default script